import Component from '../abstracts/Component';
import Crawler from 'es6-crawler-detect/src/lib/crawler';

import CarouselComponent from "./CarouselComponent";
import WishlistComponent from "./WishlistComponent";

/**
 Recommendation Engine Component
 */
export default class GoogleRecommendationEngineComponent extends Component {

  static get SELECTORS() {
    return {
      //RECOMMENDATION_ENGINE_CONTAINER: '.w-complete-look[data-carousel-type="google-rec"]',
      RECOMMENDATION_DATA_CONTAINER: '.google-recommendation-engine-container',
      RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER: '.recommendation-engine-products-container',
      wishBtn: '.js-wishlist-cta'
    };
  }

  static get CONSTANTS() {
    return {
      RECOMMENDATION_ENGINE_URL: "/action/recommendation-google",
      GET: "GET",
      POST: "POST",
      CHECKOUT_TEMPLATE: "t-checkout-confirm"
    };
  }

  render() {
    let recommendationComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_DATA_CONTAINER);

    if (recommendationComponent != null) {
      this.setup(recommendationComponent);
    }
  }

  constructor(compEl) {
    super(compEl);
    this.carouselComponent = new CarouselComponent();
  }

  getMarketingOpts(recommendationComponent) {
    let opts = {};
    opts.webRecommendationHtmlData = true;
    let template = recommendationComponent.dataset.template;
    let checkoutTemplate = GoogleRecommendationEngineComponent.CONSTANTS.CHECKOUT_TEMPLATE;

    opts.template = template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.orderCode = recommendationComponent.dataset.orderCode;
    opts.saleMode = recommendationComponent.dataset.salemode;
    if (typeof(utag_data) !== 'undefined' && utag_data !== null && template === checkoutTemplate) {
      let products = utag_data.products;
      if (typeof(products) !== 'undefined' && products !== null) {
        try {
          opts.productsData = JSON.stringify(products);
        } catch(e) {
          this.warn("error trasform products to JSON");
        }
      }
      if (typeof(utag_data.order_total) !== 'undefined' && utag_data.order_total !== null) opts.totalPrice = utag_data.order_total;
    }

    return opts;
  }

  getSimilarOpts(recommendationComponent) {
    let opts = {};
    opts.similarHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode;
    return opts;
  }

  callServer(paramsObj, callBackOnSuccess, callBackOnFailure, timeoutTime) {
    let xhttp = new XMLHttpRequest();
    let params = new URLSearchParams();
    let template = "";
    let products = "";
    let checkoutTemplate = GoogleRecommendationEngineComponent.CONSTANTS.CHECKOUT_TEMPLATE;
    let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
    for (let key in paramsObj) {
      let value = paramsObj[key];
      if (key === "template") {
        template = value;
      }
      if (key === "productsData") {
        products = value;
      }

      params.append(key, value);
    }

//    if (timeoutTime != null) {
//      xhttp.timeout = timeoutTime;
//    }

    if(template === checkoutTemplate) {
      xhttp.open(GoogleRecommendationEngineComponent.CONSTANTS.POST, contextPath + GoogleRecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20"), false);
    } else {
      xhttp.open(GoogleRecommendationEngineComponent.CONSTANTS.GET, contextPath + GoogleRecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20"), false);
    }

    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        callBackOnSuccess(this);
      } else {
        if (this.readyState === 4 && (this.status === 204 || this.status === 500 || this.status === 404 || this.status === 302)) {
          callBackOnFailure();
        }
      }
    };

    xhttp.ontimeout = function () {
      console.log("Google rec. timeout reached..");
      callBackOnFailure();
    };

    xhttp.onerror = function () {
      callBackOnFailure();
    };

    if (template === checkoutTemplate) {
      xhttp.send(products);
    } else {
      xhttp.send();
    }
  }

  renderData(data) {
    let recommendationProductsComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_DATA_CONTAINER);

    if (recommendationProductsComponent != null) {
      recommendationProductsComponent.innerHTML = data.responseText;
      let productsContainer = recommendationProductsComponent.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER);
      // loads slick then carousel el
      this.carouselComponent.importLibrary(productsContainer, true);
      // render wishlist to link async btns
      this.wishlistComponent = new WishlistComponent(recommendationProductsComponent);
      this.wishlistComponent.render(recommendationProductsComponent.querySelectorAll(GoogleRecommendationEngineComponent.SELECTORS.wishBtn));
      this.$emit(this.$customEvents.LOAD_COMPONENT.completethelook);
    }

    let googleModel = document.getElementById("googleRecommendationModel");
    let googleTitle = document.getElementById("google-section-title");
    if (typeof(googleModel) !== 'undefined' && googleModel !== null && googleModel.value !== '' && typeof(googleTitle) !== 'undefined' && googleTitle !== null) {
      googleTitle.innerHTML = googleModel.value;
      googleTitle.classList.remove("hidden");
    }

    let carouselTitle = document.querySelector("[data-carousel-type='google-rec'] .w-c-l__title");
    if (googleModel && googleModel.value !== '' && carouselTitle.length) {
      carouselTitle.innerHTML = googleModel.value;
    }
  }

  tryAgain() {
    let recommendationComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_DATA_CONTAINER);
    this.callServer(this.getSimilarOpts(recommendationComponent), this.renderData.bind(this), this.hideComponent.bind(this), null);
  }

  hideComponent() {
    let recommendationComponent = this.$component;

    if (recommendationComponent != null) {
      recommendationComponent.closest('.w-complete-look').innerHTML = "";
    }
  }

  setup(recommendationComponent) {
    let timeout = recommendationComponent.dataset.timeout;
    let template = recommendationComponent.dataset.template;
    let CrawlerDetector = new Crawler();
    let userAgentString = navigator.userAgent;

    if (!CrawlerDetector.isCrawler(userAgentString)) {
      this.callServer(this.getMarketingOpts(recommendationComponent), this.renderData.bind(this), template === "t-product" ? this.tryAgain.bind(this) : this.hideComponent.bind(this), timeout);
    } else {
      this.hideComponent();
    }
  }

}
